/**
 * Footer Component
 *
 * Fixed footer at the bottom of the app containing:
 * - Sync status indicator
 * - Clear sync queue button (trash can)
 */

import SyncStatus from './SyncStatus';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="app-footer">
      <SyncStatus />
    </footer>
  );
}
